import VehicleMapChart from "Components/Charts/Map/Map";
import SkeletonLoader from "Components/SkeletonLoader/SkeletonLoader";
import Block from "Components/UI/Block/Block";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { getDashboardLocation } from "Redux/Dashboard/reducer";
import { selectDashboardLocationLoading } from "Redux/Dashboard/slice";
import { useAppDispatch } from "Redux/store";

const VehicleMap: React.FC<{ className?: string }> = ({ className }) => {
  const loading = useSelector(selectDashboardLocationLoading);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getDashboardLocation());
  }, [dispatch]);
  if (loading) return <SkeletonLoader height="405px" />;
  return (
    <Block className={className}>
      <h3>Location</h3>
      <VehicleMapChart />
    </Block>
  );
};
export default VehicleMap;
